import { initialDashboardStatsState, actions } from "./action";

export const DashboardStatsReducer = (state = initialDashboardStatsState, action) => {
    switch (action.type) {
        case actions.DASHBOARD_GET_STATS_SUCCESS:
            return {
                ...state,
                fileGroupStats: action.payload ? action.payload : []
            };
        
        case actions.DASHBOARD_GET_PJO_STATS_SUCCESS:
            return {
                ...state,
                pjoStats: action.payload ? action.payload : []
            };
        case actions.DASHBOARD_GET_STATS_FAILURE:
            return {
                ...state,
                fileGroupStats: []
            };
        
         case actions.DASHBOARD_GET_PJO_STATS_FAILURE:
            return {
                ...state,
                pjoStats:  []
        };
        default:
            return state;
    }
};
